import { render, staticRenderFns } from "./SectionContactUs.vue?vue&type=template&id=5e81e4b5&scoped=true"
import script from "./SectionContactUs.vue?vue&type=script&lang=js"
export * from "./SectionContactUs.vue?vue&type=script&lang=js"
import style0 from "./SectionContactUs.vue?vue&type=style&index=0&id=5e81e4b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._iyputc2ruckis4av77ubvklewu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81e4b5",
  null
  
)

export default component.exports